import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export class InsoleComponentValidators {

    // Validate when structure is left{ value: ""}
    static footSelectionValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const footSelection = control.get('footSelection')?.value;

        if (footSelection) {
            const rightGroup = control.get('right') as FormGroup;
            const rightValue = rightGroup?.get('value')?.value;

            const leftGroup = control.get('left') as FormGroup;
            const leftValue = leftGroup?.get('value')?.value;

            if (footSelection === 'left' && !leftValue && leftGroup?.get('value')?.enabled) {
                return { leftRequired: true };
            }

            if (footSelection === 'right' && !rightValue && rightGroup?.get('value')?.enabled) {
                return { rightRequired: true };
            }

            if (footSelection === 'both') {
                const leftInvalid = !leftValue && leftGroup?.get('value')?.enabled;
                const rightInvalid = !rightValue && rightGroup?.get('value')?.enabled;
                if (leftInvalid || rightInvalid) {
                    return { bothRequired: true };
                }
            }
        }

        return null;
    };

    // Validate when structure is left{ value: ""}
    static footSelectionAndBasicValueValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const footSelection = control.get('footSelection')?.value;

        if (footSelection) {
            const rightGroup = control.get('right') as FormGroup;
            const rightValue = rightGroup?.get('value')?.value;

            const leftGroup = control.get('left') as FormGroup;
            const leftValue = leftGroup?.get('value')?.value;

            if (footSelection === 'left' && !leftValue && leftGroup?.get('value')?.enabled) {
                return { leftRequired: true };
            }

            if (footSelection === 'right' && !rightValue && rightGroup?.get('value')?.enabled) {
                return { rightRequired: true };
            }

            if (footSelection === 'both') {
                const leftInvalid = !leftValue && leftGroup?.get('value')?.enabled;
                const rightInvalid = !rightValue && rightGroup?.get('value')?.enabled;
                if (leftInvalid || rightInvalid) {
                    return { bothRequired: true };
                }
            }
        }

        return null;
    };

    // Validate when structure is left{ position: "medial/lateral", medial: {value: ""}}
    // When position is medial that means has to contain medial->value and same when it's lateral
    static positionMedialLateralValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const footSelection = control.get('footSelection')?.value;
        const componentType = control.get('type')?.value;

        if (footSelection) {

            // Right foot
            const rightGroup = control.get('right') as FormGroup;
            const rightPosition = rightGroup?.get('position')?.value;

            const medialRightGroup = rightGroup?.get('medial') as FormGroup;
            const medialRightValue = medialRightGroup?.get('value')?.value;

            const lateralRightGroup = rightGroup?.get('lateral') as FormGroup;
            const lateralRightValue = lateralRightGroup?.get('value')?.value;

            // For rearfootPosting, allow value 0. For others, check if value is falsy
            const isMedialRightInvalid = componentType === 'rearfootPosting'
                ? (medialRightValue === null || medialRightValue === undefined || medialRightValue === '')
                : !medialRightValue;

            const isLateralRightInvalid = componentType === 'rearfootPosting'
                ? (lateralRightValue === null || lateralRightValue === undefined || lateralRightValue === '')
                : !lateralRightValue;

            if ((footSelection === "right" || footSelection === "both") && rightPosition === "medial" && isMedialRightInvalid && medialRightGroup?.get('value')?.enabled) {
                return { medialRightValueRequired: true };
            }

            if ((footSelection === "right" || footSelection === "both") && rightPosition === "lateral" && isLateralRightInvalid && lateralRightGroup?.get('value')?.enabled) {
                return { lateralRightValueRequired: true };
            }

            // // Left foot
            const leftGroup = control.get('left') as FormGroup;
            const leftPosition = leftGroup?.get('position')?.value;

            const medialLeftGroup = leftGroup?.get('medial') as FormGroup;
            const medialLeftValue = medialLeftGroup?.get('value')?.value;

            const lateralLeftGroup = leftGroup?.get('lateral') as FormGroup;
            const lateralLeftValue = lateralLeftGroup?.get('value')?.value;

            // For rearfootPosting, allow value 0. For others, check if value is falsy
            const isMedialLeftInvalid = componentType === 'rearfootPosting'
                ? (medialLeftValue === null || medialLeftValue === undefined || medialLeftValue === '')
                : !medialLeftValue;

            const isLateralLeftInvalid = componentType === 'rearfootPosting'
                ? (lateralLeftValue === null || lateralLeftValue === undefined || lateralLeftValue === '')
                : !lateralLeftValue;

            if ((footSelection === "left" || footSelection === "both") && (leftPosition === "medial" && isMedialLeftInvalid && medialLeftGroup?.get('value')?.enabled)) {
                console.log("medial left value: ", medialLeftValue);
                return { medialLeftValueRequired: true };
            }

            if ((footSelection === "left" || footSelection === "both") && (leftPosition === "lateral" && isLateralLeftInvalid && lateralLeftGroup?.get('value')?.enabled)) {
                return { lateraLeftValueRequired: true };
            }
        }



        return null;
    };

    // Validate that medial or lateral has some value, both can be selected
    static medialLateralAtLeastOneValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const footSelection = control.get('footSelection')?.value;

        if (footSelection) {

            // Right foot
            const rightGroup = control.get('right') as FormGroup;

            const medialRightGroup = rightGroup?.get('medial') as FormGroup;
            const medialRightValue = medialRightGroup?.get('value')?.value;

            // Allow value 0, there are cases that we have 0 as value, example: medial arch "per cast" is 0
            const isMedialRightValueInvalid = medialRightValue === null || medialRightValue === undefined || medialRightValue === '';

            const lateralRightGroup = rightGroup?.get('lateral') as FormGroup;
            const lateralRightValue = lateralRightGroup?.get('value')?.value;

            // Allow value 0, there are cases that we have 0 as value, example: medial arch "per cast" is 0
            const isLateralRightValueInvalid = lateralRightValue === null || lateralRightValue === undefined || lateralRightValue === '';

            const isRightMedialRequired = !medialRightValue && isMedialRightValueInvalid && medialRightGroup?.get('value')?.enabled;
            const isRightLateralRequired = !lateralRightValue && isLateralRightValueInvalid && lateralRightGroup?.get('value')?.enabled;

            if ((footSelection === "right" || footSelection === "both") && isRightMedialRequired && isRightLateralRequired) {
                return { medialOrLateralRightValueRequired: true };
            }

            // // Left foot
            const leftGroup = control.get('left') as FormGroup;

            const medialLeftGroup = leftGroup?.get('medial') as FormGroup;
            const medialLeftValue = medialLeftGroup?.get('value')?.value;

            // Allow value 0, there are cases that we have 0 as value, example: medial arch "per cast" is 0
            const isMedialLeftValueInvalid = medialLeftValue === null || medialLeftValue === undefined || medialLeftValue === '';

            const lateralLeftGroup = leftGroup?.get('lateral') as FormGroup;
            const lateralLeftValue = lateralLeftGroup?.get('value')?.value;

            // Allow value 0, there are cases that we have 0 as value, example: medial arch "per cast" is 0
            const isLateralLeftValueInvalid = lateralLeftValue === null || lateralLeftValue === undefined || lateralLeftValue === '';

            const isLeftMedialRequired = !medialLeftValue && isMedialLeftValueInvalid && medialLeftGroup?.get('value')?.enabled;
            const isLeftLateralRequired = !lateralLeftValue && isLateralLeftValueInvalid && lateralLeftGroup?.get('value')?.enabled;

            if ((footSelection === "left" || footSelection === "both") && isLeftMedialRequired && isLeftLateralRequired) {
                return { medialOrLateralLeftValueRequired: true };
            }

        }

        return null;
    };

    // Validate that medial or lateral width and height has some value, both can be selected
    static medialLateralWidthHeightAtLeastOneValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const footSelection = control.get('footSelection')?.value;
        if (!footSelection) return null;

        const isValueMissing = (val: any) => val === null || val === undefined || val === '';

        const isSideValid = (side: FormGroup | null): boolean => {
            if (!side) return false;

            const medial = side.get('medial') as FormGroup;
            const lateral = side.get('lateral') as FormGroup;

            const medialWidthControl = medial?.get('width')?.get('selectedName');
            const medialHeightControl = medial?.get('height')?.get('selectedName');
            const lateralWidthControl = lateral?.get('width')?.get('selectedName');
            const lateralHeightControl = lateral?.get('height')?.get('selectedName');

            const checks = [
                { control: medialWidthControl, val: medialWidthControl?.value },
                { control: medialHeightControl, val: medialHeightControl?.value },
                { control: lateralWidthControl, val: lateralWidthControl?.value },
                { control: lateralHeightControl, val: lateralHeightControl?.value }
            ];

            return !checks.some(check => check.control?.enabled && isValueMissing(check.val));
        };

        const rightGroup = control.get('right') as FormGroup;
        const leftGroup = control.get('left') as FormGroup;

        if ((footSelection === 'left' || footSelection === 'both') && !isSideValid(leftGroup)) {
            return { medialOrLateralLeftValueRequired: true };
        }

        if ((footSelection === 'right' || footSelection === 'both') && !isSideValid(rightGroup)) {
            return { medialOrLateralRightValueRequired: true };
        }

        return null;
    };

}